module.exports = __webpack_public_path__ + "img/animazione-bimbi-luna-park.518b4c2d.jpg";